import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/site';

export default function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = !isHome || scrolled;

  const linkColor = solid
    ? 'text-foreground-700 hover:text-primary-600'
    : 'text-background-50/90 hover:text-white';

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/95 backdrop-blur-md shadow-soft' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2" aria-label="策驰漫画网 首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg ${
              solid ? 'bg-primary-500 text-background-50' : 'bg-background-50/20 text-white'
            }`}
          >
            <i className="ri-flashlight-fill text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl md:text-2xl ${
              solid ? 'text-foreground-950' : 'text-white'
            }`}
          >
            策驰漫画网
          </span>
        </Link>

        <div className={`hidden items-center gap-1 md:flex ${linkColor} text-sm`}>
          {navLinks.map((l) => {
            const active = location.pathname === l.to;
            const cls = active
              ? solid
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50/20 text-white'
              : solid
              ? 'hover:bg-primary-50 hover:text-primary-600'
              : 'hover:bg-background-50/10 hover:text-white';
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`rounded-full px-4 py-2 whitespace-nowrap transition-colors ${cls}`}
              >
                {l.label}
              </Link>
            );
          })}
        </div>

        <div className="flex items-center gap-3">
          <Link
            to="/comics"
            className={`hidden whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors md:inline-flex ${
              solid
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50 text-foreground-950 hover:bg-white'
            }`}
          >
            <i className="ri-book-2-line mr-1.5"></i>开始追更
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
              solid ? 'text-foreground-950 hover:bg-background-100' : 'text-white hover:bg-white/10'
            }`}
          >
            <i className={`text-2xl ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-6 pt-2 md:hidden">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={`block rounded-lg px-3 py-3 text-sm font-medium ${
                location.pathname === l.to
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-foreground-800 hover:bg-background-100'
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/comics"
            onClick={() => setOpen(false)}
            className="mt-3 block whitespace-nowrap rounded-full bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50"
          >
            开始追更
          </Link>
        </div>
      )}
    </header>
  );
}